import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  GoogleAuthProvider,
  connectAuthEmulator,
} from 'firebase/auth';
import app from './firebaseApp';

// Same persistence as getAuth(), but without the popup/redirect resolver: that
// resolver loads Google's auth iframe on every page view. Sign-in calls pass
// browserPopupRedirectResolver explicitly instead.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
});
if (process.env.REACT_APP_USE_EMULATORS === 'true') connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
export const googleProvider = new GoogleAuthProvider();
